import Player from 'xgplayer'

const state = {
  player: null,
  playerDialog: false,
  title: '未知标题'
}

const mutations = {
  SET_PLAYER: (state, param) => {
    const { url, title } = param
    state.title = title || url.split('/').pop() || '未知标题'
    state.title = state.title.replace(/.mp4|.m4v|.wm/, '')
    state.player = new Player({
      id: 'xigua-play',
      url: url,
      autoplay: false,
      videoInit: true, // 首帧作为封面
      fluid: true, // 流式布局，跟随父级宽高
      keyShortcut: 'on' // 键盘快捷键
    })
  },
  RELOAD_PLAYER: (state, param) => {
    if (state.player) {
      const { url, title } = param
      state.title = title || url.split('/').pop() || '未知标题'
      state.title = state.title.replace(/.mp4|.m4v|.wm/, '')
      state.player.autoplay = false
      state.player.src = url
      state.player.pause()
    }
  },
  SET_DIALOG: (state, value) => {
    state.playerDialog = value
  }
}

const actions = {
  play({ dispatch, commit, state }, param) {
    if (!document.getElementById('referrer')) {
      const oMeta = document.createElement('meta')
      oMeta.id = 'referrer'
      oMeta.name = 'referrer'
      oMeta.content = 'no-referrer'
      document.getElementsByTagName('head')[0].appendChild(oMeta)
    }

    if (state.player) {
      commit('RELOAD_PLAYER', { url: param.url, title: param.title })
    } else {
      commit('SET_PLAYER', { url: param.url, title: param.title })
    }
    commit('SET_DIALOG', true)
  },
  pause({ dispatch, commit, state }) {
    if (state.player) {
      state.player.pause()
    }
    commit('SET_DIALOG', false)
  }
}

const xiguaPlayer = {
  namespaced: true,
  state,
  mutations,
  actions
}

export default xiguaPlayer
